"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterServiceImpl = void 0;
const api_external_contract_js_1 = require("@tableau/api-external-contract-js");
const InternalContract = require("@tableau/api-internal-contract-js");
const api_internal_contract_js_1 = require("@tableau/api-internal-contract-js");
const ApiShared_1 = require("../../../ApiShared");
const ExternalToInternalEnumMappings_1 = require("../../EnumMappings/ExternalToInternalEnumMappings");
const InternalToExternalEnumMappings_1 = require("../../EnumMappings/InternalToExternalEnumMappings");
const FilterModels_1 = require("../../Models/FilterModels");
const DataValueFactory_1 = require("../../Utils/DataValueFactory");
const Param_1 = require("../../Utils/Param");
const ServiceImplBase_1 = require("./ServiceImplBase");
class FilterServiceImpl extends ServiceImplBase_1.ServiceImplBase {
    get serviceName() {
        return "filter-service" /* ServiceNames.Filter */;
    }
    applyFilterAsync(visualId, fieldName, values, updateType, filterOptions) {
        const verb = api_internal_contract_js_1.VerbId.ApplyCategoricalFilter;
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'applyFilterAsync',
        };
        parameters[api_internal_contract_js_1.ParameterId.VisualId] = visualId;
        parameters[api_internal_contract_js_1.ParameterId.FieldName] = fieldName;
        if (!Array.isArray(values)) {
            throw new ApiShared_1.TableauError(api_external_contract_js_1.ErrorCodes.InvalidParameter, 'values parameter for applyFilterAsync must be an array');
        }
        parameters[api_internal_contract_js_1.ParameterId.FilterValues] = values;
        parameters[api_internal_contract_js_1.ParameterId.FilterUpdateType] = ExternalToInternalEnumMappings_1.ExternalToInternalEnumMappings.filterUpdateType.convert(updateType);
        parameters[api_internal_contract_js_1.ParameterId.IsExcludeMode] =
            filterOptions === undefined || filterOptions.isExcludeMode === undefined ? false : filterOptions.isExcludeMode;
        return this.execute(verb, parameters).then((response) => {
            return fieldName;
        });
    }
    applyRangeFilterAsync(visualId, fieldName, filterOptions) {
        const verb = api_internal_contract_js_1.VerbId.ApplyRangeFilter;
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'applyRangeFilterAsync',
        };
        if (filterOptions.min !== undefined && filterOptions.min !== null) {
            let min;
            if (filterOptions.min instanceof Date) {
                min = Param_1.Param.serializeDateForPlatform(filterOptions.min);
            }
            else {
                min = filterOptions.min;
            }
            parameters[api_internal_contract_js_1.ParameterId.FilterRangeMin] = min;
        }
        if (filterOptions.max !== undefined && filterOptions.max !== null) {
            let max;
            if (filterOptions.max instanceof Date) {
                max = Param_1.Param.serializeDateForPlatform(filterOptions.max);
            }
            else {
                max = filterOptions.max;
            }
            parameters[api_internal_contract_js_1.ParameterId.FilterRangeMax] = max;
        }
        // The null option is used with min+max for 'include-range' or 'include-range-or-null'
        if (filterOptions.nullOption) {
            parameters[api_internal_contract_js_1.ParameterId.FilterRangeNullOption] = ExternalToInternalEnumMappings_1.ExternalToInternalEnumMappings.nullOptions.convert(filterOptions.nullOption);
        }
        parameters[api_internal_contract_js_1.ParameterId.FieldName] = fieldName;
        parameters[api_internal_contract_js_1.ParameterId.VisualId] = visualId;
        return this.execute(verb, parameters).then((response) => {
            this.apiFilterHandlerCheckForCommandError(response.result);
            return fieldName;
        });
    }
    applyHierarchicalFilterAsync(visualId, fieldName, values, updateType, filterOptions) {
        const verb = api_internal_contract_js_1.VerbId.HierarchicalFilter;
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'applyHierarchicalFilterAsync',
        };
        parameters[api_internal_contract_js_1.ParameterId.VisualId] = visualId;
        parameters[api_internal_contract_js_1.ParameterId.FieldName] = fieldName;
        const hierarchicalLevels = values.levels;
        if (Array.isArray(hierarchicalLevels) && hierarchicalLevels.length > 0) {
            parameters[api_internal_contract_js_1.ParameterId.FilterLevels] = hierarchicalLevels;
        }
        else if (values.length > 0) {
            parameters[api_internal_contract_js_1.ParameterId.FilterValues] = values;
        }
        else {
            // the server command expects empty list for clearing the filter
            // it also expects eithers FilterLevels or FilterValues to be set
            parameters[api_internal_contract_js_1.ParameterId.FilterLevels] = [];
        }
        parameters[api_internal_contract_js_1.ParameterId.FilterUpdateType] = ExternalToInternalEnumMappings_1.ExternalToInternalEnumMappings.filterUpdateType.convert(updateType);
        parameters[api_internal_contract_js_1.ParameterId.IsExcludeMode] = filterOptions && !!filterOptions.isExcludeMode;
        return this.execute(verb, parameters).then((response) => {
            return fieldName;
        });
    }
    clearFilterAsync(visualId, fieldName) {
        const verb = api_internal_contract_js_1.VerbId.ClearFilter;
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'clearFilterAsync',
        };
        parameters[api_internal_contract_js_1.ParameterId.VisualId] = visualId;
        parameters[api_internal_contract_js_1.ParameterId.FieldName] = fieldName;
        return this.execute(verb, parameters).then((resposne) => {
            return fieldName;
        });
    }
    applyRelativeDateFilterAsync(visualId, fieldName, options) {
        const verb = api_internal_contract_js_1.VerbId.ApplyRelativeDateFilter;
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'applyRelativeDateFilterAsync',
        };
        parameters[api_internal_contract_js_1.ParameterId.VisualId] = visualId;
        parameters[api_internal_contract_js_1.ParameterId.FieldName] = fieldName;
        parameters[api_internal_contract_js_1.ParameterId.PeriodType] = ExternalToInternalEnumMappings_1.ExternalToInternalEnumMappings.periodType.convert(options.periodType);
        parameters[api_internal_contract_js_1.ParameterId.DateRangeType] = ExternalToInternalEnumMappings_1.ExternalToInternalEnumMappings.dateRangeType.convert(options.rangeType);
        if (options.rangeType === api_external_contract_js_1.DateRangeType.LastN || options.rangeType === api_external_contract_js_1.DateRangeType.NextN) {
            if (options.rangeN === undefined || options.rangeN === null) {
                throw new ApiShared_1.TableauError(api_external_contract_js_1.EmbeddingErrorCodes.MissingRangeNForRelativeDateFilters, 'Missing rangeN field for a relative date filter of LASTN or NEXTN.');
            }
            parameters[api_internal_contract_js_1.ParameterId.RangeN] = options.rangeN;
        }
        if (options.anchorDate !== undefined && options.anchorDate !== null) {
            parameters[api_internal_contract_js_1.ParameterId.AnchorDate] = this.convertAnchorDate(options.anchorDate);
        }
        return this.execute(verb, parameters).then((response) => {
            return response.result;
        });
    }
    getFiltersAsync(visualId) {
        const verb = api_internal_contract_js_1.VerbId.GetFilters;
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'getFiltersAsync',
        };
        parameters[api_internal_contract_js_1.ParameterId.VisualId] = visualId;
        return this.execute(verb, parameters).then((response) => {
            const filters = response.result;
            return this.convertDomainFilters(filters);
        });
    }
    getCategoricalDomainAsync(worksheetName, fieldId, domainType) {
        const verb = api_internal_contract_js_1.VerbId.GetCategoricalDomain;
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'getCategoricalDomainAsync',
        };
        parameters[api_internal_contract_js_1.ParameterId.VisualId] = {
            worksheet: worksheetName,
        };
        parameters[api_internal_contract_js_1.ParameterId.FieldId] = fieldId;
        parameters[api_internal_contract_js_1.ParameterId.DomainType] = ExternalToInternalEnumMappings_1.ExternalToInternalEnumMappings.filterDomainType.convert(domainType);
        return this.execute(verb, parameters).then((response) => {
            const domain = response.result;
            return this.convertCategoricalDomain(domain, domainType);
        });
    }
    getRangeDomainAsync(worksheetName, fieldId, domainType) {
        const verb = api_internal_contract_js_1.VerbId.GetRangeDomain;
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'getRangeDomainAsync',
        };
        parameters[api_internal_contract_js_1.ParameterId.VisualId] = {
            worksheet: worksheetName,
        };
        parameters[api_internal_contract_js_1.ParameterId.FieldId] = fieldId;
        parameters[api_internal_contract_js_1.ParameterId.DomainType] = ExternalToInternalEnumMappings_1.ExternalToInternalEnumMappings.filterDomainType.convert(domainType);
        return this.execute(verb, parameters).then((response) => {
            const domain = response.result;
            return this.convertRangeDomain(domain, domainType);
        });
    }
    getDashboardFiltersAsync() {
        const verb = api_internal_contract_js_1.VerbId.GetDashboardFilters;
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'getDashboardFiltersAsync',
        };
        return this.execute(verb, parameters).then((response) => {
            const filters = response.result;
            return this.convertDomainFilters(filters);
        });
    }
    applyDashboardFilterAsync(fieldName, values, updateType, filterOptions) {
        const verb = api_internal_contract_js_1.VerbId.DashboardCategoricalFilter;
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'applyDashboardFilterAsync',
        };
        parameters[api_internal_contract_js_1.ParameterId.FieldName] = fieldName;
        parameters[api_internal_contract_js_1.ParameterId.FilterValues] = values;
        parameters[api_internal_contract_js_1.ParameterId.FilterUpdateType] = ExternalToInternalEnumMappings_1.ExternalToInternalEnumMappings.filterUpdateType.convert(updateType);
        parameters[api_internal_contract_js_1.ParameterId.IsExcludeMode] = filterOptions && !!filterOptions.isExcludeMode;
        return this.execute(verb, parameters).then((response) => {
            return response.result;
        });
    }
    getAppliedWorksheetsAsync(worksheetName, fieldId) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const sharedFilterModel = yield this.executeGetAppliedWorksheets(worksheetName, fieldId, 'getAppliedWorksheetsAsync');
            const worksheetNames = [];
            (_a = sharedFilterModel.worksheets) === null || _a === void 0 ? void 0 : _a.map((worksheetInfo) => {
                if (worksheetInfo.isSelected) {
                    worksheetNames.push(worksheetInfo.worksheetName);
                }
            });
            return worksheetNames;
        });
    }
    setAppliedWorksheetsAsync(worksheetName, fieldName, fieldId, applyToWorksheets) {
        return __awaiter(this, void 0, void 0, function* () {
            const sharedFilterModel = yield this.executeGetAppliedWorksheets(worksheetName, fieldId, 'getAppliedWorksheetsAsyncInternal');
            if (!sharedFilterModel || !sharedFilterModel.worksheets) {
                throw new ApiShared_1.TableauError(api_external_contract_js_1.SharedErrorCodes.InternalError, 'This filter does not apply to multiple worksheets');
            }
            const allowedWorksheets = [];
            let activeWorksheet = '';
            sharedFilterModel.worksheets.forEach((worksheet) => {
                // Get active worksheet
                if (worksheet.isActive) {
                    activeWorksheet = worksheet.worksheetName;
                }
                // Populate allowed worksheets
                if (worksheet.isSelected || worksheet.isEnabled) {
                    allowedWorksheets.push(worksheet.worksheetName);
                }
            });
            if (activeWorksheet === '') {
                throw new ApiShared_1.TableauError(api_external_contract_js_1.SharedErrorCodes.InternalError, 'No active worksheet');
            }
            if (!applyToWorksheets.includes(activeWorksheet)) {
                throw new ApiShared_1.TableauError(api_external_contract_js_1.SharedErrorCodes.InternalError, `${activeWorksheet} must be included in the applied worksheets`);
            }
            applyToWorksheets.forEach((sheet) => {
                // check if it's present within compatible sheets
                if (!allowedWorksheets.includes(sheet)) {
                    throw new ApiShared_1.TableauError(api_external_contract_js_1.SharedErrorCodes.InternalError, `The field ${fieldName} isn't applicable to the worksheet ${sheet}`);
                }
            });
            const verb = api_internal_contract_js_1.VerbId.ChangeSharedFilter;
            const parameters = {};
            parameters[api_internal_contract_js_1.ParameterId.FunctionName] = 'setAppliedWorksheetsAsync';
            parameters[api_internal_contract_js_1.ParameterId.VisualId] = {
                worksheet: worksheetName,
            };
            parameters[api_internal_contract_js_1.ParameterId.FieldId] = fieldId;
            parameters[api_internal_contract_js_1.ParameterId.SharedFilterSheets] = applyToWorksheets;
            return this.execute(verb, parameters).then((response) => {
                return applyToWorksheets;
            });
        });
    }
    // Helper Methods
    executeGetAppliedWorksheets(worksheetName, fieldId, telemetryFunctionName) {
        const verb = api_internal_contract_js_1.VerbId.GetSharedFilter;
        const parameters = {};
        parameters[api_internal_contract_js_1.ParameterId.FunctionName] = telemetryFunctionName;
        parameters[api_internal_contract_js_1.ParameterId.VisualId] = {
            worksheet: worksheetName,
        };
        parameters[api_internal_contract_js_1.ParameterId.FieldId] = fieldId;
        return this.execute(verb, parameters).then((response) => {
            const sharedFilterModel = response.result;
            return sharedFilterModel;
        });
    }
    convertDomainFilters(domainFilters) {
        const filters = [];
        domainFilters.forEach((domainFilter) => {
            switch (domainFilter.filterType) {
                case api_internal_contract_js_1.FilterType.Categorical: {
                    const filter = domainFilter;
                    if (filter) {
                        filters.push(this.convertCategoricalFilter(filter));
                    }
                    else {
                        throw new Error('Invalid Categorical Filter');
                    }
                    break;
                }
                case api_internal_contract_js_1.FilterType.Hierarchical: {
                    const filter = domainFilter;
                    if (filter) {
                        filters.push(this.convertHierarchicalFilter(filter));
                    }
                    else {
                        throw new Error('Invalid Hierarchical Filter');
                    }
                    break;
                }
                case api_internal_contract_js_1.FilterType.Range: {
                    const filter = domainFilter;
                    if (filter) {
                        filters.push(this.convertRangeFilter(filter));
                    }
                    else {
                        throw new Error('Invalid Range Filter');
                    }
                    break;
                }
                case api_internal_contract_js_1.FilterType.RelativeDate: {
                    const filter = domainFilter;
                    if (filter) {
                        filters.push(this.convertRelativeDateFilter(filter));
                    }
                    else {
                        throw new Error('Invalid Relative Date Filter');
                    }
                    break;
                }
                default: {
                    break;
                }
            }
        });
        return filters;
    }
    convertCategoricalFilter(domainFilter) {
        const appliedValues = domainFilter.values.map((dv) => {
            return DataValueFactory_1.DataValueFactory.MakeFilterDataValue(dv);
        });
        return new FilterModels_1.CategoricalFilter(domainFilter.visualId.worksheet, domainFilter.fieldCaption, domainFilter.fieldName, api_external_contract_js_1.FilterType.Categorical, this._registryId, appliedValues, domainFilter.isExclude, domainFilter.isAllSelected);
    }
    convertHierarchicalFilter(domainFilter) {
        const appliedValues = domainFilter.values.map((hierarchicalDataValue) => {
            return new FilterModels_1.HierarchicalDataValue(DataValueFactory_1.DataValueFactory.MakeFilterDataValue(hierarchicalDataValue.value), hierarchicalDataValue.hierarchicalPath, hierarchicalDataValue.level);
        });
        const levelDetails = domainFilter.levelInfo.map((aLevel) => {
            return new FilterModels_1.HierarchicalLevelDetail(aLevel.name, InternalToExternalEnumMappings_1.InternalToExternalEnumMappings.hierarchicalLevelSelectionState.convert(aLevel.levelSelectionState));
        });
        return new FilterModels_1.HierarchicalFilter(domainFilter.visualId.worksheet, domainFilter.fieldCaption, domainFilter.fieldName, api_external_contract_js_1.FilterType.Hierarchical, this._registryId, domainFilter.dimensionName, domainFilter.hierarchyCaption, domainFilter.levels, levelDetails, appliedValues, domainFilter.isAllSelected);
    }
    convertRangeFilter(domainFilter) {
        const minValue = DataValueFactory_1.DataValueFactory.MakeFilterDataValue(domainFilter.min);
        const maxValue = DataValueFactory_1.DataValueFactory.MakeFilterDataValue(domainFilter.max);
        return new FilterModels_1.RangeFilter(domainFilter.visualId.worksheet, domainFilter.fieldCaption, domainFilter.fieldName, api_external_contract_js_1.FilterType.Range, this._registryId, minValue, maxValue, domainFilter.includeNullValues);
    }
    convertRelativeDateFilter(domainFilter) {
        const anchorDateValue = DataValueFactory_1.DataValueFactory.MakeFilterDataValue(domainFilter.anchorDate);
        return new FilterModels_1.RelativeDateFilter(domainFilter.visualId.worksheet, domainFilter.fieldCaption, domainFilter.fieldName, api_external_contract_js_1.FilterType.RelativeDate, this._registryId, anchorDateValue, InternalToExternalEnumMappings_1.InternalToExternalEnumMappings.dateStepPeriod.convert(domainFilter.periodType), InternalToExternalEnumMappings_1.InternalToExternalEnumMappings.dateRangeType.convert(domainFilter.rangeType), domainFilter.rangeN);
    }
    convertCategoricalDomain(domain, domainType) {
        const values = domain.values.map((domainDv) => {
            return DataValueFactory_1.DataValueFactory.MakeFilterDataValue(domainDv);
        });
        return new FilterModels_1.CategoricalDomain(values, domainType);
    }
    convertRangeDomain(domain, domainType) {
        const min = DataValueFactory_1.DataValueFactory.MakeFilterDataValue(domain.min);
        const max = DataValueFactory_1.DataValueFactory.MakeFilterDataValue(domain.max);
        return new FilterModels_1.RangeDomain(min, max, domainType);
    }
    convertAnchorDate(anchorDate) {
        // Converts a Date object into a string format that the server expects for date/time values.
        // If anchorDate doesn't represent a valid Date object, any of these would be NaN.
        const year = anchorDate.getUTCFullYear();
        const month = anchorDate.getUTCMonth() + 1;
        const day = anchorDate.getUTCDate();
        const hh = anchorDate.getUTCHours();
        const mm = anchorDate.getUTCMinutes();
        const sec = anchorDate.getUTCSeconds();
        if (isNaN(year) || isNaN(month) || isNaN(day) || isNaN(hh) || isNaN(mm) || isNaN(sec)) {
            throw new ApiShared_1.TableauError(api_external_contract_js_1.EmbeddingErrorCodes.InvalidDateParameter, 'Invalid date parameter: anchorDate');
        }
        const result = `${year}-${month}-${day} ${hh}:${mm}:${sec}`;
        return result;
    }
    apiFilterHandlerCheckForCommandError(serverPm) {
        if (!serverPm[InternalContract.ParameterId.ParameterError]) {
            return;
        }
        if (serverPm[InternalContract.ParameterId.InvalidFieldCaption]) {
            throw new ApiShared_1.TableauError(api_external_contract_js_1.SharedErrorCodes.InvalidFilterFieldName, serverPm[InternalContract.ParameterId.InvalidFieldCaption]);
        }
        if (serverPm[InternalContract.ParameterId.InvalidValues]) {
            throw new ApiShared_1.TableauError(api_external_contract_js_1.SharedErrorCodes.InvalidFilterFieldValue, serverPm[InternalContract.ParameterId.InvalidValues]);
        }
        if (serverPm[InternalContract.ParameterId.InvalidAggFieldName]) {
            throw new ApiShared_1.TableauError(api_external_contract_js_1.SharedErrorCodes.InvalidAggregationFieldName, serverPm[InternalContract.ParameterId.InvalidAggFieldName]);
        }
        throw new ApiShared_1.TableauError(api_external_contract_js_1.SharedErrorCodes.ServerError, 'Server Error');
    }
}
exports.FilterServiceImpl = FilterServiceImpl;
//# sourceMappingURL=FilterServiceImpl.js.map